import request from '@/utils/request';

// 获取栏目数据
export function getCatalogData() {
  return request({
    url: '/api/common/catalog',
    method: 'get'
  })
}

// 获取内容列表
export function getContentList(query) {
  return request({
    url: '/api/common/content',
    params:query,
    method: 'get'
  })
}

// 获取内容列表
export function getList(query) {
  return request({
    url: '/api/common/contentList',
    params:query,
    method: 'get'
  })
}

// 获取内容数据
export function getContentData(catalogId,contentType,contentId) {
  return request({
    url: '/api/common/content/'+catalogId+'/'+contentType+'/'+contentId,
    method: 'get'
  })
}

// 获取内容分类字典
export function getContentTypeDict(dictType,catalogId) {
  return request({
    url: '/api/common/type/'+dictType+'/'+catalogId,
    method: 'get'
  })
}

// 提交联系我们的数据
export function submitContactusData(data) {
  return request({
    url: '/api/common/addContactus',
    data:data,
    method: 'post'
  })
}

// 提交数据
export function submiCommonData(data) {
  return request({
    url: '/api/common/addCommonData',
    data:data,
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 获取手机验证码
export function getPhoneCode(phone,type) {
  console.log("phone",phone)
  return request({
    url: '/api/common/send/' + phone + type+ '/interAspect',
    method: 'get'
  })
}

//工资单查询
export function getSalary(query) {
  console.log("Salary", query)
  return request({
    url: '/api/common/salarylist',
    data: query,
    method: "post"
  })
}

//证书查询
export function getCert(query){
  console.log("Cert",query)
  return request({
    url: '/api/common/certInfo',
    data:query,
    method: "post"
  })
}
  //保存预约信息
  export function addAppointment(body){
    console.log("appointment",body)
    return request({
      url: '/api/common/addAppointment',
      data:body,
      method: "post"
    })
}
  
// 获取文件列表
export function getFileList(query) {
  return request({
    url: '/api/common/fileList',
    params:query,
    method: 'get'
  })
}

// 获取内容列表
export function getCourseList(query) {
  return request({
    url: '/api/common/courselist',
    params:query,
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/apiRequest.js